export default "__VITE_ASSET__BeqKqn_S__"